module fdm.aircrafts {
    export class AircraftService {
   
    }

    angular.module('fdm.aircrafts')
        .service('aircraftsService', AircraftService);
}